import { render, staticRenderFns } from "./OPPayableDetail.vue?vue&type=template&id=df0c8b70&"
import script from "./OPPayableDetail.vue?vue&type=script&lang=js&"
export * from "./OPPayableDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports